import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface DistributionItem {
  key: string
  value: number
  color: string
}

interface Props {
  items: DistributionItem[]
  showEmpty?: boolean
  emptyColor?: string
  height?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UIDistributionBar',
  props: {
    items: null,
    showEmpty: { type: Boolean, default: false },
    emptyColor: { default: 'ink-100' },
    height: { default: 'h-4' }
  },
  setup(__props: any) {

const props = __props as { items: DistributionItem[], showEmpty: boolean, emptyColor: string, height: string };



const visibleItems = computed(() => {
  return props.items.filter((item) => item.value > 0)
})

const hasVisibleItems = computed(() => {
  return visibleItems.value.length > 0
})

return { __sfc: true,props, visibleItems, hasVisibleItems }
}

})